<template>
    <div>
    <div class="row" v-for="product in products" :key="'invoiceproduct_'+product.id">
            <div class="columns" >
                <div class="column is-4">
                    <strong>Naam</strong><br>
                    <b-input type="text" v-model="product.name" v-if="editingProducts" expanded></b-input>
                    <span v-else class="productname">
                        {{ product.name }}
                        <b-button tag="router-link" size="is-small" v-if="(product.type == 'box' || product.type == 'product') && product.product" :to="{ name: (product.type == 'box' ? 'BoxesRecord' : 'ProductsRecord'), params: { id: product.product } }" icon-right="external-link-alt"></b-button>
                    </span>
                </div>
                <div class="column">
                    <strong>{{ product.type == 'box' ? '' : 'Aantal' }}</strong><br>
                    {{ product.type == 'box' ? '' : product.amount }}
                </div>
                <div class="column text-right">
                    <span v-if="type != 'credit'">
                        <strong>Borg</strong><br>
                        <span v-if="editingProducts">
                            <b-input type="text" v-model="product.deposit" icon="euro-sign" expanded></b-input>
                        </span>
                        <span v-else>
                            <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                            <span v-else>{{ product.deposit > 0 ? '€ '+number_format((product.amount ? product.amount : 1) * product.deposit) : '-' }}</span>
                        </span>
                    </span>
                </div>
                <div class="column text-right">
                    <strong>BTW prijs</strong><br>
                    <span v-if="editingProducts">
                        <b-input type="text" v-model="product.btw_price" icon="euro-sign" expanded></b-input>
                    </span>
                    <span v-else>
                        <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                        <span v-else>&euro;&nbsp;{{ number_format(product.btw_price) }}</span>
                    </span>
                </div>
                <div class="column text-right">
                    <strong>Totaal</strong><br>
                    <span v-if="editingProducts">
                        <b-input type="text" v-model="product.price" icon="euro-sign" expanded></b-input>
                    </span>
                    <span v-else>
                        <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                        <span v-else>&euro;&nbsp;{{ number_format(((product.amount ? product.amount : 1) * product.price) + (product.deposit ? product.deposit * product.amount : 0)) }}</span>
                    </span>
                </div>
            </div>
        </div>
        <div v-if="showTotals && record">
            <hr>
            <div class="row">
                <div class="columns">
                    <div class="column is-4">&nbsp;</div>
                    <div class="column">&nbsp;</div>
                    <div class="column">&nbsp;</div>
                    <div class="column text-right">
                        <strong>Totaal BTW</strong><br>
                        <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                        <span v-else>&euro;&nbsp;{{ record.btw }}</span>
                    </div>
                    <div class="column text-right">
                        <strong>Totaal</strong><br>
                        <span v-if="type == 'credit'" class="text-danger">
                            <span v-if="hideSensitiveData">- &euro;&nbsp;*****</span>
                            <span v-else>-&nbsp;&euro;&nbsp;{{ record.total }}</span>
                        </span>
                        <span v-else>
                            <span v-if="hideSensitiveData">&euro;&nbsp;*****</span>
                            <span v-else>&euro;&nbsp;{{ record.total }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductsSummary',

    props: {
        type: {
            type: String,
            required: false,
            default: 'view'
        },
        products: {
            type: Array,
            required: false,
            default: () => []
        },
        record: {
            type: Object,
            required: false,
            default: () => {}
        },
        showTotals: {
            type: Boolean,
            required: false,
            default: false
        },
        editingProducts: {
            type: Boolean,
            required: false,
            default: false
        },
        includedIn: {
            type: String,
            required: false,
            default: ''
        }
    },

    computed: {
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        }
    },

    methods: {
        number_format(val, decimals = 2) {
            val = parseFloat(val)
            return val.toFixed(decimals)
        }
    }
}
</script>